export default "__VITE_ASSET__OoIohFTT__"